import { Badge } from '@frontend/components';

import { QUOTE_ITEM_STATUS, QUOTE_ITEM_STATUS_LABEL } from 'constants/all';

export const QuoteItemStatusBadge = ({ status }) => {
  switch (status) {
    case QUOTE_ITEM_STATUS.NOT_STARTED:
      return (
        <Badge
          bg="feature.secondary"
          borderColor="feature.secondary"
          color="feature.onInteraction"
        >
          {QUOTE_ITEM_STATUS_LABEL[QUOTE_ITEM_STATUS.NOT_STARTED]}
        </Badge>
      );
    case QUOTE_ITEM_STATUS.IN_PROGRESS:
      return (
        <Badge colorScheme="warning">
          {QUOTE_ITEM_STATUS_LABEL[QUOTE_ITEM_STATUS.IN_PROGRESS]}
        </Badge>
      );
    case QUOTE_ITEM_STATUS.NO_QUOTE:
      return (
        <Badge
          bg="page.plateMedium"
          borderColor="page.plateMedium"
          color="feature.onInteraction"
        >
          {QUOTE_ITEM_STATUS_LABEL[QUOTE_ITEM_STATUS.NO_QUOTE]}
        </Badge>
      );
    case QUOTE_ITEM_STATUS.ON_HOLD:
      return (
        <Badge colorScheme="error">
          {QUOTE_ITEM_STATUS_LABEL[QUOTE_ITEM_STATUS.ON_HOLD]}
        </Badge>
      );
    case QUOTE_ITEM_STATUS.COMPLETED:
      return (
        <Badge colorScheme="success">
          {QUOTE_ITEM_STATUS_LABEL[QUOTE_ITEM_STATUS.COMPLETED]}
        </Badge>
      );
    default:
      return null;
  }
};
